import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "EstadoViaticoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "EstadoViaticoPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexEstadoViatico(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'EstadoViatico', name: 'EstadoViatico', title: 'Estado Viatico' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                //{ data: 'Rol', name: 'Rol', title: 'Rol' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            estadoviaticos: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            estadoviatico: {},
            
        };
    },
    methods: {
               
        newEstadoViatico() {
            this.estadoviatico = {};
            this.$refs['frm-estadoviatico'].show();
            // console.log("hhhhola")
        },
        showEstadoViatico(id) {
            this.isLoading=true;
            this.ss.showEstadoViatico(id).then(
                (result) => {
                    let response = result.data;
                    this.estadoviatico = response.data;
                    this.$refs['view-estadoviatico'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editEstadoViatico() {
            this.$refs['frm-estadoviatico'].show();
            this.$refs['view-estadoviatico'].hide();
        },
        cancelEstadoViatico() {
            if (this.estadoviatico.id) {
                this.$refs['view-estadoviatico'].show();
            }
            this.$refs['frm-estadoviatico'].hide();
        },
        saveEstadoViatico() {
            this.ss.storeEstadoViatico(this.estadoviatico).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-estadoviatico'].hide();
                    this.$refs['datatable-estadoviatico'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteEstadoViatico() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyEstadoViatico(this.estadoviatico)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-estadoviatico'].hide();
                                this.$refs['datatable-estadoviatico'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-estadoviatico'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-estadoviatico'].show();
        },
        changePassword() {
            this.password.EstadoViatico = this.estadoviatico.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-estadoviatico'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-EstadoViatico').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showEstadoViatico(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
